import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3357f3e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "divider" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-divider" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "mobile-divider__line" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoHeaderDivider = _resolveComponent("MoHeaderDivider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MoHeaderDivider, { class: "desktop-divider" }, {
      "left-col": _withCtx(() => [
        _renderSlot(_ctx.$slots, "left-col", {}, undefined, true)
      ]),
      "right-col": _withCtx(() => [
        _renderSlot(_ctx.$slots, "right-col", {}, undefined, true)
      ]),
      _: 3
    }),
    _hoisted_2
  ]))
}